const images = {
  webinar_logo: require('../images/webinar_logo.png'),
  avatar: require('../images/Default.png'),
  anet: require('../images/anet.png'),
  teacherIcon: require('../images/workshop_icon_3color.png'),
  studentIcon: require('../images/ic_school_black_24px (1).png'),
  signupCompleteIcon: require('../images/icon-signup-complete.png'),
  stars: require('../images/_ _ _ _ _ _.png'),
  profilePic: require('../images/Profile Pic.png'),
  inviteUserIcon: require('../images/new.png'),
  inviteUserBigIcon: require('../images/Shape.png'),
  cardBackground: require('../images/card_background.jpg'),
  guestmodeBackground: require('../images/shutterstock_90267736.png'),
  successImage: require('../images/Success image.png'),
  expired: require('../images/Expired.png'),
  csv: require('../images/Bitmap.png'),
  signup: require('../images/signup-background.png'),
  error: require('../images/error.png')
};

export default images;



// WEBPACK FOOTER //
// ./src/config/images.js